import { Avatar } from '@mui/material';
import React from 'react';

import defaultImage from '../../images/Empty_candidate_profile.svg';

interface WsCustomAvatarProps {
  src?: string;
  alt?: string;
  borderRadius?: string;
  size?: number;
}

const WsCustomAvatar: React.FC<WsCustomAvatarProps> = ({
  src,
  alt = 'Profile Picture',
  borderRadius = '0%',
  size = 50,
}) => {
  return (
    <Avatar
      src={src || defaultImage}
      alt={alt}
      sx={{
        width: size,
        height: size,
        borderRadius,
        objectFit: 'cover',
      }}
    />
  );
};

export default WsCustomAvatar;
